import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "layanan", label: "Layanan" },
    { id: "harga", label: "Harga" },
    { id: "syarat-ketentuan", label: "Syarat & Ketentuan" },
    { id: "member", label: "Member" },
    { id: "testimoni", label: "Testimoni" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <header className="fixed inset-x-0 top-0 z-50 px-4 pt-4 sm:px-6">
            <div className="mx-auto max-w-7xl rounded-2xl border border-white/50 bg-white/70 shadow-brand backdrop-blur-xl">
                <nav className="flex h-16 items-center justify-between px-5 sm:px-7">
                    <button
                        data-testid="nav-logo"
                        onClick={() => go("beranda")}
                        className="flex items-center gap-2.5"
                        aria-label="DigiKlin — kembali ke atas"
                    >
                        <img
                            src="/logo-icon.png"
                            alt="Logo DigiKlin"
                            className="h-10 w-auto rounded-xl bg-white"
                        />
                        <span className="font-display text-xl font-bold tracking-tight text-ink">
                            Digi<span className="text-brand">Klin</span>
                        </span>
                    </button>

                    <div className="hidden items-center gap-8 md:flex">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`nav-link-${l.id}`}
                                onClick={() => go(l.id)}
                                className="text-sm font-semibold text-ink/70 transition-colors duration-200 hover:text-brand"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid="nav-cta"
                            onClick={() => go("form")}
                            className="rounded-full bg-brand px-6 py-2.5 text-sm font-bold text-white shadow-brand transition-all duration-200 hover:-translate-y-0.5 hover:bg-brand-deep hover:shadow-brand-lg"
                        >
                            Pesan Antar Jemput
                        </button>
                    </div>

                    <button
                        data-testid="nav-mobile-toggle"
                        className="grid h-10 w-10 place-items-center rounded-full text-ink md:hidden"
                        onClick={() => setOpen((v) => !v)}
                        aria-label="Buka menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </nav>

                {open && (
                    <div className="border-t border-brand-mist px-5 pb-6 pt-2 md:hidden">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`nav-mobile-link-${l.id}`}
                                onClick={() => go(l.id)}
                                className="block w-full rounded-xl px-3 py-3 text-left text-base font-semibold text-ink/80 transition-colors hover:bg-brand-mist/60"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid="nav-mobile-cta"
                            onClick={() => go("form")}
                            className="mt-3 w-full rounded-full bg-brand px-6 py-3 text-sm font-bold text-white"
                        >
                            Pesan Antar Jemput
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
}
